<script>
import appConfig from "@/app.config";
import axios from 'axios';

export default {
  name: "app",
  /*
  metaInfo: {
    titleTemplate: '%s | 대구여성인권센터',
    meta: [
      { charset: 'utf-8' },
      { name: 'viewport', content: 'width=device-width,initial-scale=1.0' },
      { name: 'description', content: '대구여성인권센터 성착취 없는 세상을 희망하고 상상하고 행동하는 일' },
      { name: 'keywords', content: '대구여성인권센터, 반성매매운동, 성매매문제해결, 여성인권, 대구여성단체, 대구여성상담' },
      { property: 'og:type', content: 'website' },
      { property: 'og:site_name', content: '대구여성인권센터' },
      { property: 'og:locale', content: 'ko_KR' },
      { property: 'og:image', content: 'http://himne.org/images/_decen/logo/logo_old.png' },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:image', content: 'http://himne.org/images/_decen/logo/logo_old.png' }
    ],
    link: [
      { rel: 'canonical', href: 'https://www.himne.org/' }
    ]
  },
  */
  data() {
    return {
      baseInfo: false,
      isIpBlocked: false,
    }
  },
  components: {
  },
  watch: {
    $route(to, from) {
      // clear alert on location change
      //this.clearNotification();
    },
  },
  created() {
    // mounted보다 먼저 실행되어 API 호출을 더 빨리 시작
    this.r_base_homeinfo();
  },
  mounted() {
    //this.r_base_homeinfo();
    /*
    // 테마 사용부분
    let localTheme = localStorage.getItem('theme'); //gets stored theme value if any
    if (localTheme !=='darkMode') {
      document.documentElement.setAttribute('data-theme', 'lightMode'); // updates the data-theme attribute
    } else {
      document.documentElement.setAttribute('data-theme', localTheme); // updates the data-theme attribute
    }
    // document.getElementsByTagName("html")[0].setAttribute("dir", "rtl");
    */
  },
  methods: {
    // 홈페이지 기본정보
    async r_base_homeinfo() {
      try {
        await axios({
          method: 'POST',
          url: appConfig.fastapi + '/auth/r_base_homeinfo',
          data: {
            "is_login": false,
          },
        })
        .then((res) => {
          if (res.data) {
            if (res.data.type == 'error') {
              // ip 차단의 경우 여기에 해당함
              //this.$notify({ type: 'error', duration: 3000, title: '실패', text: res.data.text })
              this.isIpBlocked = true;
              this.baseInfo = false;
            } else {
              if (res.data.baseData && res.data.boardData) {
                this.$store.commit('setWebSiteInfoBase', res.data.baseData);
                this.$store.commit('setWebSiteInfoBoard', res.data.boardData);
              }
              this.isIpBlocked = false;
            }
          }
        })
        .catch((error) => {
          if (error.response) {
            this.$notify({ type: 'error', duration: 3000, 'title': error.response.status+' 에러', text: error.response.data.detail })
            if (error.response.text == 'not allowed country') {
              this.baseInfo = true;
              // 404 처리하자 중국, 싱가포르 차단!
              this.$router.push('/page-error');
            }
          }
          if (error.code=='ERR_NETWORK') {
            this.$notify({ type: 'error', duration: 3000, 'title': '서버오류', text: error.message})
            this.baseInfo = true;
            this.$router.push('/page-error');
          }
        })
      } catch (error) {
        this.$notify({ type: 'error', duration: 3000, title: '실패', text: '요청 중 에러 발생 관리자에게 문의'+error })
        this.baseInfo = true;
        this.$router.push('/page-error');
      } finally {
        // IP 차단된 경우 baseInfo를 false로 유지
        if (!this.isIpBlocked) {
          this.baseInfo = true;
        }
      }
    },
  },
};
</script>

<template>
  <div id="app">
    <notifications position="center" class="p-3"></notifications>
    <div v-if="baseInfo">
      <!-- 라우트된 컴포넌트를 표시하는 부분 key로 $route.fullPath 넣으면 경로 인식 제대로함 -->
      <router-view :key="$route.fullPath"/>
    </div>
  </div>
</template>

<style lang="scss">
</style>